import React, { useEffect, useRef, useState } from "react";

function Employmentbasedgreencardimport() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);
  const contentRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    sectionRefs.current = sectionRefs.current.slice(0, 4);

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = sectionRefs.current.indexOf(entry.target);
          setActiveIndex(index);
        }
      });
    }, observerOptions);

    sectionRefs.current.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const scrollToSection = (index) => {
    setActiveIndex(index);
    const section = sectionRefs.current[index];
    const contentElement = contentRef.current;

    const scrollPosition = section.offsetTop - contentElement.offsetTop;

    contentElement.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  };

  return (
    <div className="flex flex-wrap">
      <div className=" mt-20 flex min-h-screen">
        <div
          ref={titleRef}
          className="sticky top-20 hidden h-screen w-1/4 overflow-y-auto bg-gray-100 p-4 md:block"
        >
          <ul className="space-y-2">
            <li
              onClick={() => scrollToSection(0)}
              className={`cursor-pointer p-8 ${
                activeIndex === 0
                  ? "bg-blue-500 text-white"
                  : "bg-white text-[#2C3F69]"
              } shadow rounded-md`}
            >
              How to Apply
            </li>
            <li
              onClick={() => scrollToSection(1)}
              className={`cursor-pointer p-8 ${
                activeIndex === 1
                  ? "bg-blue-500 text-white"
                  : "bg-white text-[#2C3F69]"
              } shadow rounded-md`}
            >
              Documents Required
            </li>
            <li
              onClick={() => scrollToSection(2)}
              className={`cursor-pointer p-8 ${
                activeIndex === 2
                  ? "bg-blue-500 text-white"
                  : "bg-white text-[#2C3F69]"
              } shadow rounded-md`}
            >
              Visa Interview Process
            </li>
            <li
              onClick={() => scrollToSection(3)}
              className={`cursor-pointer p-8 ${
                activeIndex === 3
                  ? "bg-blue-500 text-white"
                  : "bg-white text-[#2C3F69]"
              } shadow rounded-md`}
            >
              Why Choose Visa World
            </li>
          </ul>
        </div>

        <div
          ref={contentRef}
          className="mb-10 h-screen overflow-y-auto p-4 md:w-3/4 lg:w-3/4 xl:w-3/4"
        >
          <div ref={(el) => (sectionRefs.current[0] = el)}>
            <p className="text-xl font-bold text-[#011473]">
              How to Apply for a US Student Visa
            </p>
            <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
              <li>
                Complete the DS-160 Form: Fill out the Non-immigrant Visa
                Electronic Application (DS-160) form with accurate and
                authentic information.
              </li>
              <li>Seek assistance from an immigration lawyer or translator if needed.</li>
              <li>
                Pay the Application Fee: Submit the required payment to
                complete your profile creation. Retain your application ID or
                number for scheduling appointments.
              </li>
              <li>
                Schedule Appointments: Book two appointments—Visa Application
                Center (VAC) for biometrics and document verification and the
                U.S. Embassy or Consulate for the visa interview.
              </li>
            </ul>
          </div>

          <div ref={(el) => (sectionRefs.current[1] = el)} className="mt-10">
            <p className="text-xl font-bold text-[#011473]">
              Documents Required for a US Student Visa
            </p>
            <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
              <li>Valid Passport: Must be valid for at least six months beyond your stay.</li>
              <li>DS-160 Confirmation Page: Proof of completed application.</li>
              <li>
                Application Fee Receipt: Required if payment is made before the
                interview.
              </li>
              <li>Photograph: Upload online or carry a physical photo per DS-160 standards.</li>
              <li>Form I-20: Certificate of Eligibility provided by your SEVP-certified institution.</li>
              <li>Test Scores: Include TOEFL, SAT, ACT, or other admission test results.</li>
              <li>Academic Records: Transcripts, diplomas and certificates.</li>
              <li>
                Financial Evidence: Proof of funds to cover education, living,
                and travel expenses.
              </li>
            </ul>
          </div>

          <div ref={(el) => (sectionRefs.current[2] = el)} className="mt-10">
            <p className="text-xl font-bold text-[#011473]">Visa Interview Process</p>
            <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
              <li>
                Attend the interview at a U.S. consulate or embassy. Be
                prepared to provide additional documents like academic
                credentials, intent to return home after studies and proof of
                financial stability.
              </li>
              <li>
                Biometrics (fingerprint scans) will be taken during the interview.
              </li>
              <li>
                If approved, pay a visa issuance fee (if applicable) and
                arrange for passport return.
              </li>
            </ul>
          </div>

          <div ref={(el) => (sectionRefs.current[3] = el)} className="mt-10">
            <p className="text-xl font-bold text-[#011473]">
              Why Choose Visa World
            </p>
            <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
              <li>
                Trusted Expertise: Extensive experience in immigration, visa
                processing and study abroad services.
              </li>
              <li>
                Personalized Approach: Tailored solutions based on your unique
                needs and goals.
              </li>
              <li>
                Comprehensive Support: Assistance with documentation,
                application management and legal representation throughout the
                immigration process.
              </li>
              <li>
                Reliable Guidance: Skilled professionals ensure a smooth and
                stress-free application process.
              </li>
            </ul>
            <p className="mt-4 text-md text-[#2C3F69]">
              Contact Visa World today to start your journey to the United States!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Employmentbasedgreencardimport;
